// extracted by mini-css-extract-plugin
export default {"heroSection":"HeroSectionStyles_heroSection__etfar","videoBackground":"HeroSectionStyles_videoBackground__L2mkg","content":"HeroSectionStyles_content__SMitg"};